import { render, staticRenderFns } from "./tableBixuanTaocan.vue?vue&type=template&id=768eba0c"
import script from "./tableBixuanTaocan.vue?vue&type=script&lang=js"
export * from "./tableBixuanTaocan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports